import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import { FC, useCallback } from 'react'

import { getPromptAnswer } from '../../../components/Inspections/getPromptAnswer'
import useAccessTokenAndShopId from '../../../hooks/useAccessTokenAndShopId/useAccessTokenAndShopId'
import {
  EntryWithRelated,
  NotInspectedDummyEntry,
  PromptWithRelated
} from '../../../models/inspections'
import {
  useUpdateInspectionEntryMutation,
  useUpdateInspectionPromptMutation
} from '../../../redux/api/inspectionApi'
import { InspectionEntryStatusEntry } from '../../../sdk'

interface Props {
  prompt: PromptWithRelated
  entry: EntryWithRelated
  setEntry: (entry: EntryWithRelated) => void
  allStatuses: InspectionEntryStatusEntry[] | undefined
  handleSelectAnswer: (updatedEntry: EntryWithRelated) => void
}
export const PromptSelectForSingleSelect: FC<Props> = ({
  prompt,
  entry,
  setEntry,
  allStatuses,
  handleSelectAnswer
}) => {
  const { accessToken } = useAccessTokenAndShopId()
  const [updatePrompt] = useUpdateInspectionPromptMutation()
  const [updateEntry] = useUpdateInspectionEntryMutation()
  const onSubmitForMultipleChoice = useCallback(
    async (answerId: string) => {
      const updatedPrompt: PromptWithRelated = {
        ...prompt,
        info: {
          ...prompt.info!,
          answer: undefined,
          multipleChoiceAnswer: answerId || undefined,
          multipleChoiceMultipleSelectAnswers: undefined
        }
      }
      const answer = prompt.answers.find((answer) => answer.id === answerId)
      const updatedEntry: EntryWithRelated = {
        ...entry,
        info: {
          ...entry.info!,
          customStatus: answer?.info!.status || entry.info!.customStatus,
          customerNotes: answer?.info!.customerNotes
        },
        status:
          allStatuses?.find(
            (s) => s.id === (answer?.info!.status || entry.info!.customStatus)
          ) || NotInspectedDummyEntry,
        prompts: [updatedPrompt]
      }
      // update UI before sending request
      setEntry(updatedEntry)
      handleSelectAnswer(updatedEntry)
      updatePrompt({
        authorization: accessToken,
        promptEntry: updatedPrompt
      })

      updateEntry({
        authorization: accessToken,
        entryEntry: updatedEntry
      })
    },
    [
      accessToken,
      allStatuses,
      entry,
      handleSelectAnswer,
      prompt,
      setEntry,
      updateEntry,
      updatePrompt
    ]
  )

  return (
    <FormControl variant="standard" required={prompt.info?.required}>
      <InputLabel id="select-answer-label">Answer</InputLabel>
      <Select
        labelId="select-answer-label"
        id="select-answer"
        value={getPromptAnswer(prompt.info!) as string}
        onChange={(event) => {
          onSubmitForMultipleChoice(event.target.value)
        }}
        label="Answer"
        required={prompt.info?.required}>
        {prompt.answers.map((answer) => (
          <MenuItem value={answer.id} key={answer.id!}>
            {answer.info?.question}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
